import { CommonModule } from '@angular/common'
import { Component, input, output } from '@angular/core'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, Grid } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { GridColumnGroupComponent } from '../../shared/reusable-components/grid-column-group/grid-column-group.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { GridSelectionCalculationComponent } from '../../shared/reusable-components/grid-selection-calculation/grid-selection-calculation.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { bindPurchasedMaterialTab, PurchasedMaterialFilters, purchasedMaterialScopeKey } from './purchased-material-filters'

interface MaterialItem {
    description: string
    partNumber: string
    vendorCount: number
    lineCount: number
    quantity: number
    spend: number
    unit: string
    medianUnitPrice: number | null
    firstDate: string
    lastDate: string
}

@Component({
    selector: 'app-purchased-materials-items',
    templateUrl: './purchased-materials-items.component.html',
    standalone: true,
    imports: [
        CommonModule,
        ActionToolbarCount,
        GridExportComponent,
        GridColumnGroupComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
        GridSelectionCalculationComponent,
    ],
})
export class PurchasedMaterialsItemsComponent extends BaseComponent {
    filters = input.required<PurchasedMaterialFilters>()
    active = input(false)
    priceHistory = output<string>()

    itemGrid: Grid<MaterialItem>

    constructor() {
        super()
        this.itemGrid = new Grid<MaterialItem>(this.services).wrapColumnHeaders()
        bindPurchasedMaterialTab(
            this.filters,
            this.active,
            filters => purchasedMaterialScopeKey(filters, true),
            () => this.clear(),
            filters => this.load(filters),
        )
    }

    openPriceHistory() {
        const item = this.itemGrid.selectedItem as MaterialItem | null
        if (!item?.description) return
        this.priceHistory.emit(item.description)
    }

    private clear() {
        this.itemGrid.items = []
    }

    private load(filters: PurchasedMaterialFilters) {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(true, true, this.services.data.post('/api/PurchasedMaterials/GetItems', filters))
                .subscribe({
                    next: result => {
                        this.itemGrid.items = result[0].items
                    },
                }),
        )
    }
}
